// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"380":"06ba6db1","529":"e6f734db","999":"9ce0af0a"}[chunkId] + ".css";
};